import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Icon from '../../../core/Icon';
import Menu from '@material-ui/core/Menu';
import Divider from '@material-ui/core/Divider';
import { MenuItem, withStyles, createStyles } from '@material-ui/core';
/** A select dropdown for selecting Google and Safe fonts */

/**
 * @extends {React.PureComponent<import('./types').NumericDropdownProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */

var NumericDropdown =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NumericDropdown, _React$PureComponent);

  function NumericDropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NumericDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NumericDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      anchorEl: null
    };

    _this.handleClick = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    };

    _this.handleClose = function () {
      _this.setState({
        anchorEl: null
      });
    };

    _this.onChange = function (value) {
      _this.props.onChange(value);

      if (_this.state.anchorEl) _this.handleClose();
    };

    _this.renderCurrentValue = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          showCurrentValueInDropdown = _this$props.showCurrentValueInDropdown,
          formatLabel = _this$props.formatLabel,
          classes = _this$props.classes;
      if (!showCurrentValueInDropdown) return null;
      return [React.createElement(MenuItem, {
        key: "currentValue",
        className: classes.menuItem,
        onClick: function onClick() {
          return _this.onChange(value);
        }
      }, formatLabel(value)), React.createElement(Divider, {
        key: "currentValueDivider"
      })];
    };

    _this.renderOption = function (option, idx) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          classes = _this$props2.classes;

      var optionValue = _this.getOptionValue(option);

      return React.createElement(MenuItem, {
        key: idx,
        className: classes.menuItem,
        onClick: function onClick() {
          return _this.onChange(optionValue);
        },
        selected: optionValue === value
      }, _this.getOptionLabel(option));
    };

    _this.getOptionLabel = function (option) {
      var formatLabel = _this.props.formatLabel;

      var optionValue = _this.getOptionValue(option);

      var label = optionValue;
      if (typeof option.label !== 'undefined') label = option.label;else if (formatLabel) label = formatLabel(optionValue);
      return label;
    };

    _this.getOptionValue = function (option) {
      if (option === null) return null;
      var optionValue = null;
      if (typeof option === 'number') optionValue = option;else if (typeof option.value !== 'undefined') optionValue = option.value;
      return optionValue;
    };

    return _this;
  }

  _createClass(NumericDropdown, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          options = _this$props3.options,
          classes = _this$props3.classes;
      var anchorEl = this.state.anchorEl;
      /** @type {any} */

      var menuProps = {
        id: 'long-menu',
        anchorEl: anchorEl,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        classes: {
          paper: classes.menu
        }
      };
      return React.createElement("div", {
        className: classes.root,
        "data-testid": "numeric-dropdown"
      }, React.createElement(Icon, {
        type: "down-filled",
        onClick: this.handleClick,
        className: classes.icon
      }), React.createElement(Menu, Object.assign({}, menuProps, {
        open: Boolean(anchorEl),
        onClose: this.handleClose
      }), this.renderCurrentValue(), options.map(this.renderOption)));
    }
  }]);

  return NumericDropdown;
}(React.PureComponent);

var styles = function styles(theme) {
  return createStyles({
    root: {
      position: 'relative'
    },
    menu: {
      width: 100
    },
    menuItem: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: 0,
      paddingBottom: 0,
      height: theme.spacing(4)
    },
    icon: {
      fontSize: '1.2rem',
      color: 'rgba(0, 0, 0, 0.54)',
      marginRight: 2
    }
  });
};

NumericDropdown.defaultProps = {
  showCurrentValueInDropdown: true
};
export default withStyles(styles, {
  name: 'ECNumericDropdown'
})(NumericDropdown);